// extracted by mini-css-extract-plugin
module.exports = {"activate-button":"ActivateButton_activate-button__2v9Tg","deactivate-button":"ActivateButton_deactivate-button__1zTB1"};